import TrackPaceDisplay from "./TrackPaceDisplay";
export default TrackPaceDisplay;